import React from "react";
import PropTypes from "prop-types";

import { Accordion as MaterialAccordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { useFormikContext } from "formik";
import { isEmpty } from "lodash";

import { TitleWithHorizontalLine } from "../TitleWithHorizontalLine";
import { IconWrapper, Wrapper, AccordionDiv } from "./styled";
import { ICONS, Icon } from "../Icons";
import { log } from "../../utils/loggger";

export const FormAccordian = props => {
  const formik = useFormikContext();
  const labelsConstant = [];
  const [formLabels, setFormLabels] = React.useState([]);
  const [expanded, setExpanded] = React.useState(props.toggle);

  const extractLabels = props => {
    try {
      if (Array.isArray(props)) {
        props.forEach(element => {
          if (element.props !== undefined && element.props.name !== undefined) {
            labelsConstant.push(element.props.name);
          } else {
            if (element.props !== undefined && element.props.children !== undefined) {
              extractLabels(element.props.children);
            }
          }
        });
      }
      if (props.children !== undefined) {
        if (Array.isArray(props.children)) {
          extractLabels(props.children);
        } else {
          extractLabels(props.children.props.children);
        }
      }
      if (labelsConstant.length > 0) setFormLabels(labelsConstant);
    } catch (error) {
      log(error);
    }
  };

  React.useEffect(() => {
    extractLabels(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    setExpanded(props.toggle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.toggle]);

  React.useEffect(() => {
    if (!isEmpty(formik.errors))
      formLabels.forEach(element => {
        if (formik.errors[element.split(".")[0]] !== undefined) {
          setExpanded(true);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik]);

  return (
    <AccordionDiv customStyle={props.customStyle}>
      {" "}
      <MaterialAccordion
        sx={{ background: "transparent", boxShadow: "none" }}
        className="panel"
        expanded={expanded}
      >
        {props.title !== null && (
          <AccordionSummary aria-controls="panel1a-content" id="panel1a-header">
            <Wrapper>
              <TitleWithHorizontalLine>{props.title}</TitleWithHorizontalLine>
              <IconWrapper>
                <Icon
                  className="smallIcon"
                  alt="collapse-icon"
                  name={expanded ? ICONS.minimizeChat : ICONS.arrowDown}
                />
              </IconWrapper>
            </Wrapper>
          </AccordionSummary>
        )}
        <AccordionDetails data-testid="accordion-content" sx={{ p: 0 }}>
          {props.children}
        </AccordionDetails>
      </MaterialAccordion>
    </AccordionDiv>
  );
};

FormAccordian.propTypes = {
  /**
   * The title to be displayed in the accordion header
   */
  title: PropTypes.node,
  /**
   * Controls whether the accordion is expanded or collapsed
   */
  toggle: PropTypes.bool,
  /**
   * The content to be displayed inside the accordion
   */
  children: PropTypes.node.isRequired,
  /**
   * Custom styles to be applied to the accordion container
   */
  customStyle: PropTypes.object
};
